export default __webpack_public_path__ + "static/media/duraflex.39b82802.png";